import { Component, defineComponent, onMounted, defineAsyncComponent  } from 'vue';
import SuccessMessage from '@/presentation/components/success-message/success-message.vue';
import OrganisationDetailsBlock from '@/presentation/components/organisation-details-block/organisation-details-block.vue';
import Accordion from '@/presentation/components/accordion/accordion.vue';
import UserDetailsForm from '@/presentation/components/user-details-form/user-details-form.vue';
import SearchInput from '@/presentation/components/search-input/search-input.vue';
import DeleteConfirmationModal from '@/presentation/components/delete-confirmation-modal/delete-confirmation-modal.vue';
import OrganisationCode from '@/presentation/pages/organisation/organisation.code';
import tableComponentLoader from '@/presenters/table-component-loader';

export default defineComponent({
	components: {
		SuccessMessage: SuccessMessage as Component,
		OrganisationDetailsBlock: OrganisationDetailsBlock as Component,
		OrganisationUsersTable: defineAsyncComponent(tableComponentLoader.loadOrganisationUsersTable.bind(tableComponentLoader)),
		Accordion: Accordion as Component,
		UserDetailsForm: UserDetailsForm as Component,
		SearchInput: SearchInput as Component,
		DeleteConfirmationModal: DeleteConfirmationModal as Component
	},
	setup: () => {
		const code = new OrganisationCode();

		onMounted(code.mounted.bind(code));

		return {
			searchTypeUser: code.searchTypeUser,
			isModalConfirmationStateDelete: code.isModalConfirmationStateDelete,
			amountOfUsersText: code.amountOfUsersText,
			isNewUserAccordionOpen: code.isNewUserAccordionOpen,
			toggleNewUserAccordion: code.toggleNewUserAccordion.bind(code),
			navigateToUserActionsPage: code.navigateToUserActionsPage.bind(code)
		};
	}
});
